import { render, staticRenderFns } from "./vodCardStatic.vue?vue&type=template&id=a4aaecd6&scoped=true&"
import script from "./vodCardStatic.vue?vue&type=script&lang=js&"
export * from "./vodCardStatic.vue?vue&type=script&lang=js&"
import style0 from "./vodCardStatic.vue?vue&type=style&index=0&id=a4aaecd6&scoped=true&lang=css&"
import style1 from "./vodCardStatic.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4aaecd6",
  null
  
)

export default component.exports